import { Component, OnInit } from '@angular/core';
import { PartenariatService } from 'src/app/_services/partenariat/partenariat.service';

@Component({
  selector: 'app-carousel-font',
  templateUrl: './carousel-font.component.html',
  styleUrls: ['./carousel-font.component.css']
})
export class CarouselFontComponent implements OnInit {

  cards_s = [];
  cards_p = [];

  slides1: any = [[]];
  slides2: any = [[]];
  chunk(arr, chunkSize) {
    let R = [];
    for (let i = 0, len = arr.length; i < len; i += chunkSize) {
      R.push(arr.slice(i, i + chunkSize));
    }
    return R;
  }

  constructor( private servicePart : PartenariatService) {
    setTimeout( () => {  
      this.slides1 = this.chunk(this.cards_s, 6);
      this.slides2 = this.chunk(this.cards_p, 6);
    
       },3000 );
   }

  ngOnInit(): void {


    this.servicePart.Afficherpartenariat().subscribe(res=>{
      res.forEach(element => {
        if (element.type=='font'){
        this.cards_p.push({
         img: "http://notregrandbleu.org/assets/img/sponsoring/"+element.image
        });}
        else {this.cards_s.push({
          img: "http://notregrandbleu.org/assets/img/sponsoring/"+element.image
         });}
      });
      
  });

  }

}
